import React from "react";
import AuthWizardProvider from "../../common/wizard/AuthWizardProvider";
import Payment from "../payment/Index";
import bgImage from "../../../assets/img/logos/api-award-2022.jpg";
import SaiAuthCardLayout from "./SaiAuthCardLayout";

const SaiRegistration = () => {
  return (
    <>
      <AuthWizardProvider>
        <SaiAuthCardLayout bgProps={{ image: bgImage }}>
          <Payment validation={true} />
        </SaiAuthCardLayout>
      </AuthWizardProvider>
    </>
  );
};

export default SaiRegistration;
